<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  name: string;
  userImage: string | undefined;
  isSelf: boolean;
}>();

// Fallback for a member with no picture: getUserImage() looks the member up in the tenant user list
// and returns undefined when they aren't there (still on the project, no longer in the tenant), and
// an <img> with no src renders as a broken image.
const initials = computed(() =>
  props.name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("")
);
</script>

<template>
  <div class="flex min-w-0 items-center gap-3">
    <img
      v-if="userImage"
      class="h-8 w-8 shrink-0 rounded-full object-cover"
      :src="userImage"
      :alt="name" />
    <div
      v-else
      class="t-caption-bold text-type-muted flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-200"
      aria-hidden="true">
      {{ initials }}
    </div>
    <span class="t-small text-type-default truncate">{{ name }}</span>
    <span
      v-if="isSelf"
      class="t-caption text-type-muted shrink-0">
      you
    </span>
  </div>
</template>
